export default {
  categories: (state) => state.categories,
  category: (state) => state.category,
  categoryHelpers: (state) => state.categoryHelpers
}



// WEBPACK FOOTER //
// ./src/components/category/store/getters.js